export default __webpack_public_path__ + "static/media/TotalTeachersIcon.88ca2f11.svg";